import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class MovableStripe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moveDirection: undefined,
    };
  }

  render() {
    return (
      <div
        className={
          this.props.history.location.pathname.includes("/grave")
            ? "movable-stripe movable-stripe-grave"
            : "movable-stripe"
        }>
        <div
          onClick={() => this.props.onDirectionMove("top")}
          className='movable-arr arrow-top'
        />
        <div
          onClick={() => this.props.onDirectionMove("bottom")}
          className='movable-arr arrow-bottom'
        />
        <div className='stripe' />
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withRouter(connect(mapStateToProps)(MovableStripe));



// WEBPACK FOOTER //
// ./src/js/components/movable-stripe/index.js